import React from "react";
import moment from "moment";
import { ChevronRight } from "lucide-react";

import BottomSheet from "src/components/app/BottomSheet";
import type { CgmDateRange } from "src/types/cgm.types";
import { DateRange } from "@material-symbols-svg/react";

interface CGMSensorCycleBottomSheetProps {
  open: boolean;
  close: () => void;
  dateRanges: CgmDateRange[];
  onSelectDateRange: (dateRange: CgmDateRange) => void;
}

const CGMSensorCycleBottomSheet: React.FC<CGMSensorCycleBottomSheetProps> = ({
  open,
  close,
  dateRanges,
  onSelectDateRange,
}) => {
  return (
    <BottomSheet
      show={open}
      handleClose={close}
      title="Select Cumulative Report"
      showCloseButton
    >
      <div className="pb-4">
        {dateRanges.length === 0 ? (
          <p className="px-4 py-6 text-sm text-gray-500 text-center">
            No sensor cycles available
          </p>
        ) : (
          dateRanges.map((dateRange, index) => (
            <button
              key={`sensor-cycle-${index}`}
              type="button"
              className="flex w-full items-center gap-2 px-4 py-3 border-b border-gray-200 last:border-b-0 hover:bg-gray-50 active:bg-gray-100 text-left"
              onClick={() => onSelectDateRange(dateRange)}
            >
              <div className="p-2 rounded-full bg-[var(--icon-bg-primary)] text-[var(--app-primary)]">
                <DateRange className="w-4 h-4" />
              </div>
              <div className="flex-1">
                <div className="text-base font-semibold text-gray-900">
                  {moment(dateRange.start_date).format("MMM D")} –{" "}
                  {moment(dateRange.end_date).format("MMM D")}
                </div>
                <div className="text-sm text-gray-500">
                  {moment(dateRange.end_date).diff(
                    moment(dateRange.start_date),
                    "days"
                  )}{" "}
                  days
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-gray-400" />
            </button>
          ))
        )}
      </div>
    </BottomSheet>
  );
};

export default CGMSensorCycleBottomSheet;
